import Header from '../components/Header';
import HamburgerMenu from '../components/HamburgerMenu';
import ItemExperience from '../components/ItemExperience';
import profile from '../assets/profile_picture.png';
import '../styles/AboutMe.css';
import Footer from '../components/Footer';
import { useApp } from '../context/AppContext';

const AboutMe = () =>{
    const {menuActive, toggleMenu} = useApp();

    return (
        <div>
            <Header setOpenMenu={toggleMenu}></Header>
            <main className='about'>
                <section className='about-me'>
                    <picture>
                        <img src={profile} alt="" />
                    </picture>
                    <div className='about-me_intro'>
                        <h2>¿Quien es George Muñoz?</h2>
                        <p>
                        Desarrollador Frontend originario de Puebla, México. Soy Ingeniero en Ciencias de la Computación con interés en el desarrollo web, especialmente en el Frontend. No obstante también me gusta aprender de UX/UI con el fin de tener mejores habilidades en diseño.
                        </p>
                    </div>
                </section>
                <section className='about-me__experience'>
                    <h2>Experiencia Profesional</h2>
                    <ItemExperience 
                        title="· Grupo Más Ecommerce | Septiembre 2022 -  Actualidad" 
                        description="Trabajo desarrollando consultas SQL y código PHP que permitan dar solución a las diferentes necesidades que surgen dentro de la empresa para poder mejorar el trabajo en otras areas."
                        />
                    <ItemExperience 
                        title="· RUBBER. | Mayo 2022 - Agosto 2022" 
                        description="Diseño y desarrollo web responsivo asi como el despliegue mismo del sitio."
                    />
                    <ItemExperience 
                        title="· The Geo Engineering | Febr 2022 - Abr 2022" 
                        description="Diseño y desarrollo web responsivo asi como el despliegue mismo del sitio."
                    />
                    <ItemExperience 
                        title="· FCC, BUAP. | Mayo 2021 - Noviembre 2021" 
                        description="Diseño UI responsivo y desarrollo de aplicación web"
                    />

                    <h2>Educación</h2>
                    <ItemExperience 
                        title=' Ingeniería en Ciencias de la Computación'
                        description='Benemérita Universidad Autónoma de Puebla - Licenciatura | 2017 - 2023'
                    />
                    <ItemExperience
                        title='Frontend Developer'
                        description='Platzi'
                    />
                </section>
            </main>
            <Footer/>
            <HamburgerMenu isOpenMenu={menuActive} setOpenMenu={toggleMenu}></HamburgerMenu>
        </div>
    );

}

export default AboutMe;